export default __webpack_public_path__ + "static/media/keto_urination@3x.bccfb5f0.jpg";